import Key from "./SVG/key.svg?react";

const KeyIcon = () => {
  return <Key />;
};

export default KeyIcon;
